import zIndex from "@mui/material/styles/zIndex";

export const styleSheet = () => ({
  root: {
    position: "sticky",
    top: 124,
    height: "60px",
    backgroundColor: "#f7f6f8",
    padding: "0px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 999,
  },
  tabsLeft: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 0px",
    height: "60px",
    "& .MuiTypography-root": {
      fontSize: "12px !important",
    },
  },
  tabsArea: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "10px 0px",
    height: "60px",
    "& .MuiTypography-root": { fontSize: "10px !important" },
  },
  buttonItemActive: {
    width: "60px",
    height: "60px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
    cursor: "pointer",
    color: "white",
    backgroundColor: "#2868D7 !important",
    "& g": {
      stroke: "white", // strokes in group
    },
  },
  buttonItem: {
    width: "60px",
    height: "60px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#E5E5E5",
    },
  },
  buttonIcon: {
    width: "22px",
    height: "22px",
  },
  buttonText: {
    fontSize: "12px !important",
    fontWeight: "500",
    marginTop: "0px !important",
  },
  selectBox: {
    width: "146px",
    marginLeft: "10px !important",
    marginRight: "20px !important",
    "& .MuiSelect-select": {
      minHeight: "0px !important",
      height: "30px",
      backgroundColor: "white !important",
      paddingTop: "4px !important",
      paddingBottom: "4px !important",
      fontSize: "12px !important",
    },
    "& .MuiMenuItem-root": {
      fontSize: "12px !important",
    },
  },
  menuCard: {
    width: "246px",

    "& .MuiTypography-root": {
      fontSize: "12px !important",
    },
  },
  editButton: {
    textTransform: "capitalize !important",
    fontSize: "9px !important",
    textDecoration: "underline !important",
    color: "#2868D7 !important",
    marginRight: "-20px  !important",
  },
});
